import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const characters = 250;
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <div className="text">
      {isReadMore ? text.slice(0, characters) : text}
      {text && text.length > characters && (
        <span onClick={toggleReadMore} className="read-or-hide">
          {isReadMore ? " ...read more" : " read less"}
        </span>
      )}
    </div>
  );
};
export default ReadMore;
